import { CONFIG_ENVIRONMENT, CONFIG_SENTRY_DSN, CONFIG_VERSION } from '../../config';
import { LogAppender } from './logger';
import * as Sentry from '@sentry/browser';

/* eslint-disable @typescript-eslint/no-explicit-any */

export function initSentry(): void {
  try {
    Sentry.init({
      dsn: CONFIG_SENTRY_DSN,
      environment: CONFIG_ENVIRONMENT,
      release: CONFIG_VERSION
    });
  } catch (ex) {
    console.error(ex);
  }
}

export function stringify(args: any[]): string {
  return args.map((item) => `${item instanceof Error ? item.toString() : JSON.stringify(item)}`).join(' ');
}

export const sentryAppender: LogAppender = {
  warn: (...args) => {
    Sentry.captureMessage(stringify(args), Sentry.Severity.Warning);
  },
  error: (...args) => {
    if (Sentry && typeof Sentry.captureMessage === 'function') {
      Sentry.captureMessage(stringify(args), Sentry.Severity.Error);
    }
  }
};
